/*
  Panier Ripcorde : comportement du tiroir rendu par sections/rc-cart.liquid.
  Toute la logique d'affichage (suggestions, seuil, cadeaux) est en Liquid ;
  ce script poste au panier et remplace [data-rc-inner] par la version rendue
  (Section Rendering API, parametre `sections` des requetes /cart/*.js).

  - window.RcCart.open({ fresh: true }) : appele par les boites d'achat apres
    un ajout (rc-buybox-script, rc-atc-script, rc-variant-buybox).
  - Les requetes du panier lancees par d'autres scripts (EasyGift qui ajoute
    ses cadeaux, code FIT10 de rc-klaviyo-code) sont reperees par un
    PerformanceObserver : il voit toutes les requetes, qui que soit leur
    auteur, sans surcharger fetch. Nos propres requetes portent ?rc=1 pour
    etre ignorees.
  - Les formulaires /cart/add classiques (fiches Dawn : Ripbands...) sont
    interceptes en phase de capture et postes tels quels (FormData) :
    Shopify comprend items[N][id], contrairement a UpCart.
  - Le verrou de defilement pose overflow:hidden sur body pendant
    l'ouverture seulement, comme le menu de rc-header.
  - Cadeaux (remplace EG Auto Add To Cart) et protection du colis : la section
    dit ce qui doit etre au panier ([data-rc-gifts], [data-rc-prot]) ; syncAll
    ajoute ou retire les lignes, sans message d'erreur visible, et s'arrete
    apres 4 corrections en 10 s pour ne jamais boucler contre une autre app.
*/
(function () {
  'use strict';
  /* id avec tirets : un id « RcCart » creerait window.RcCart (acces nomme du
     navigateur) et ferait croire que le script est deja charge. */
  var box = document.getElementById('rc-cart-drawer');
  if (!box || (window.RcCart && window.RcCart.enabled)) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var SECTION = box.getAttribute('data-section') || 'rc-cart';
  var panel = box.querySelector('.rc-cart__panel');
  var liveEl = box.querySelector('[data-rc-live]');
  var errEl = box.querySelector('[data-rc-err]');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var isOpen = false, dirty = false, lastFocus = null, refreshTimer = null, closeTimer = null, fixing = false;
  /* EG Auto Add To Cart encore actif (sa balise meta et son script sont dans le
     HTML des le chargement) : il garde la main sur les cadeaux. Sinon il bloque
     nos ajouts par un alert() « Ce produit fait partie d'une promotion
     limitee… » a chaque page (vu le 27/09 dans l'editeur). */
  var EG_ACTIVE = !!(document.getElementById('easygift-shop') || document.querySelector('script[src*="cdn.506.io/eg/"]') || window.EasyGift);
  /* Editeur de theme : on ne modifie jamais le panier. */
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  function q(sel, el) { return (el || box).querySelector(sel); }
  function say(msg) { if (liveEl) { liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = msg; }, 30); } }
  function showErr(msg) {
    if (!errEl) return;
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  }

  /* ---------- rendu ---------- */
  function swap(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-rc-inner]');
    var cur = q('[data-rc-inner]');
    if (!next || !cur) return;
    var b = q('[data-rc-body]');
    var top = b ? b.scrollTop : 0;
    /* Le focus clavier etait dans le contenu remplace : on le remet sur le
       controle de meme rang, sinon il tomberait sur body (et Echap, Tab
       sortiraient du tiroir). */
    var fIdx = -1;
    if (cur.contains(document.activeElement)) fIdx = focusables().indexOf(document.activeElement);
    cur.innerHTML = next.innerHTML;
    var nb = q('[data-rc-body]');
    if (nb) nb.scrollTop = top;
    if (fIdx > -1 && isOpen) {
      var f = focusables();
      var el = f[Math.min(fIdx, f.length - 1)] || panel;
      el.focus({ preventScroll: true });
    }
    dirty = false;
    syncCount();
    syncAll();
    document.dispatchEvent(new CustomEvent('rc-cart:updated'));
  }

  function refresh() {
    return fetch(ROOT + '?sections=' + encodeURIComponent(SECTION), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d[SECTION]) swap(d[SECTION]); })
      .catch(function () {});
  }

  /* Requete au panier, JSON, avec rendu de la section dans la reponse. */
  function send(path, payload, silent) {
    payload.sections = SECTION;
    payload.sections_url = window.location.pathname;
    if (!silent) { box.setAttribute('aria-busy', 'true'); showErr(''); }
    return fetch(ROOT + path + '?rc=1', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (r) {
        box.removeAttribute('aria-busy');
        if (!r.ok) {
          if (!silent) showErr((r.d && (r.d.description || r.d.message)) || "L'ajout au panier a échoué. Réessayez.");
          return refresh().then(function () { return false; });
        }
        if (r.d && r.d.sections && r.d.sections[SECTION]) swap(r.d.sections[SECTION]);
        else return refresh().then(function () { return true; });
        return true;
      })
      .catch(function () {
        box.removeAttribute('aria-busy');
        if (!silent) showErr('La connexion a échoué. Vérifiez votre réseau et réessayez.');
        return false;
      });
  }

  /* ---------- en-tete du site : nombre d'articles (sans cadeaux ni protection) ---------- */
  function syncCount() {
    var src = q('[data-rc-count]');
    if (!src) return;
    var n = parseInt(src.getAttribute('data-rc-count'), 10) || 0;
    var a = document.getElementById('cart-icon-bubble');
    if (!a) return;
    var c = a.querySelector('[data-rc-cart-count]');
    var sr = a.querySelector('[data-rc-cart-count-sr]');
    if (n > 0) {
      if (!c) {
        c = document.createElement('span');
        c.className = 'rc-hd__count';
        c.setAttribute('data-rc-cart-count', '');
        c.setAttribute('aria-hidden', 'true');
        a.appendChild(c);
      }
      c.textContent = n;
      if (!sr) {
        sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.setAttribute('data-rc-cart-count-sr', '');
        a.appendChild(sr);
      }
      sr.textContent = n + (n > 1 ? ' articles' : ' article');
    } else {
      if (c) c.remove();
      if (sr) sr.remove();
    }
  }

  /* ---------- cadeaux puis protection du colis ---------- */
  var fixTimes = [];
  function canFix() {
    var now = Date.now();
    fixTimes = fixTimes.filter(function (t) { return now - t < 10000; });
    if (fixTimes.length >= 4) return false;
    fixTimes.push(now);
    return true;
  }
  function done() { fixing = false; syncAll(); }
  function syncAll() {
    if (fixing || DESIGN) return;

    /* 1. Cadeaux : un jeu par commande, seulement avec un produit declencheur. */
    var g = q('[data-rc-gifts]');
    if (g && g.getAttribute('data-on') === '1' && !EG_ACTIVE) {
      var want = g.getAttribute('data-want') === '1';
      var ids = (g.getAttribute('data-ids') || '').split(',').filter(Boolean);
      var mark = g.getAttribute('data-mark') || 'OFFERT';
      /* « cle|variante|quantite; » : la cle de ligne contient deja « : ». */
      var lines = (g.getAttribute('data-lines') || '').split(';').filter(Boolean).map(function (x) {
        var p = x.split('|');
        return { key: p[0], id: p[1], qty: parseInt(p[2], 10) || 0 };
      });
      var updates = {}, seen = {}, need = [];
      lines.forEach(function (l) {
        if (!want || ids.indexOf(l.id) < 0 || seen[l.id]) { updates[l.key] = 0; return; }
        seen[l.id] = true;
        if (l.qty !== 1) updates[l.key] = 1;
      });
      if (want) ids.forEach(function (id) { if (!seen[id]) need.push(id); });
      var hasUp = Object.keys(updates).length > 0;
      if ((hasUp || need.length) && canFix()) {
        fixing = true;
        (hasUp ? send('cart/update.js', { updates: updates }, true) : Promise.resolve(true))
          .then(function () {
            if (!need.length) return true;
            return send('cart/add.js', { items: need.map(function (id) { return { id: Number(id), quantity: 1, properties: { _Gifted: mark } }; }) }, true);
          })
          .then(done, done);
        return;
      }
    }

    /* 2. Protection seule dans un panier vide : retiree. */
    var orphan = q('[data-rc-prot-orphan]');
    if (orphan && canFix()) {
      fixing = true;
      send('cart/change.js', { id: orphan.getAttribute('data-rc-prot-orphan'), quantity: 0 }, true).then(done, done);
      return;
    }

    /* 3. Protection au bon palier (3,95 EUR sous 79 EUR, 4,95 EUR au-dela). */
    var p = q('[data-rc-prot]');
    if (!p) return;
    var cur = p.getAttribute('data-current'), exp = p.getAttribute('data-expected');
    if (cur && exp && cur !== exp && canFix()) {
      fixing = true;
      var up = {};
      up[cur] = 0;
      up[exp] = 1;
      send('cart/update.js', { updates: up }, true).then(done, done);
    }
  }

  /* ---------- ouverture / fermeture ---------- */
  function focusables() {
    return [].slice.call(panel.querySelectorAll('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function open(opts) {
    opts = opts || {};
    clearTimeout(closeTimer);
    if (!isOpen) {
      isOpen = true;
      lastFocus = document.activeElement;
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      var go = function () { box.classList.add('is-open'); };
      if (reduce) go(); else requestAnimationFrame(function () { requestAnimationFrame(go); });
      setTimeout(function () {
        var c = q('.rc-cart__close');
        (c || panel).focus({ preventScroll: true });
      }, 40);
      document.dispatchEvent(new CustomEvent('rc-cart:open'));
    }
    if (opts.fresh || dirty) return refresh();
    return Promise.resolve();
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    box.classList.remove('is-open');
    document.body.style.overflow = '';
    closeTimer = setTimeout(function () { box.hidden = true; }, reduce ? 0 : 340);
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('rc-cart:close'));
  }

  document.addEventListener('keydown', function (e) {
    if (isOpen && e.key === 'Escape') { e.preventDefault(); close(); }
  });
  box.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- actions dans le tiroir ---------- */
  box.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rc-close],[data-rc-qty],[data-rc-add],[data-rc-var],[data-rc-prot-toggle]');
    if (!t || !box.contains(t)) return;

    if (t.hasAttribute('data-rc-close')) { e.preventDefault(); close(); return; }

    if (t.hasAttribute('data-rc-qty')) {
      var qty = parseInt(t.getAttribute('data-rc-qty'), 10);
      if (isNaN(qty) || qty < 0) qty = 0;
      t.disabled = true;
      send('cart/change.js', { id: t.getAttribute('data-key'), quantity: qty }).then(function (ok) {
        if (ok) say(qty === 0 ? 'Article retiré du panier.' : 'Quantité mise à jour.');
      });
      return;
    }

    if (t.hasAttribute('data-rc-var')) {
      var card = t.closest('[data-rc-card]');
      if (!card) return;
      [].forEach.call(card.querySelectorAll('[data-rc-var]'), function (b) { b.setAttribute('aria-pressed', String(b === t)); });
      var add = card.querySelector('[data-rc-add]');
      if (add) {
        add.setAttribute('data-id', t.getAttribute('data-id'));
        add.setAttribute('data-props', t.getAttribute('data-props') || '{}');
      }
      var price = card.querySelector('[data-rc-price]');
      if (price) {
        price.textContent = t.getAttribute('data-price') || '';
        var cmp = t.getAttribute('data-compare');
        if (cmp) { var s = document.createElement('s'); s.textContent = cmp; price.appendChild(s); }
      }
      var note = card.querySelector('[data-rc-note]');
      if (note) { note.textContent = t.getAttribute('data-note') || ''; note.hidden = !t.getAttribute('data-note'); }
      return;
    }

    if (t.hasAttribute('data-rc-add')) {
      var props = {};
      try { props = JSON.parse(t.getAttribute('data-props') || '{}'); } catch (err) { props = {}; }
      var title = t.getAttribute('data-title') || 'Article';
      t.disabled = true;
      send('cart/add.js', { items: [{ id: Number(t.getAttribute('data-id')), quantity: 1, properties: props }] }).then(function (ok) {
        if (ok) say(title + ' ajouté au panier.');
        else t.disabled = false;
      });
      return;
    }

    if (t.hasAttribute('data-rc-prot-toggle')) {
      var p = t.closest('[data-rc-prot]');
      if (!p) return;
      var on = t.getAttribute('aria-checked') === 'true';
      t.setAttribute('aria-checked', String(!on));
      if (on && p.getAttribute('data-key')) {
        send('cart/change.js', { id: p.getAttribute('data-key'), quantity: 0 });
      } else if (!on) {
        send('cart/add.js', { items: [{ id: Number(p.getAttribute('data-expected')), quantity: 1, properties: { _rc_panier: 'protection' } }] });
      }
    }
  });

  /* ---------- icone panier de l'en-tete ---------- */
  /* Phase de capture : le panier maison passe avant tout autre script qui
     ecouterait l'icone (UpCart tant qu'il n'est pas desactive). */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    open({ fresh: dirty });
  }, true);

  /* ---------- formulaires /cart/add classiques (fiches Dawn) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM' || box.contains(f)) return;
    var action = f.getAttribute('action') || '';
    if (!/\/cart\/add(\.js)?(\?|$)/.test(action)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(f);
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);
    fetch(ROOT + 'cart/add.js?rc=1', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (r) {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (!r.ok) {
          open({ fresh: true });
          showErr((r.d && (r.d.description || r.d.message)) || "L'ajout au panier a échoué. Réessayez.");
          return;
        }
        if (r.d && r.d.sections && r.d.sections[SECTION]) { swap(r.d.sections[SECTION]); open(); }
        else open({ fresh: true });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        HTMLFormElement.prototype.submit.call(f);
      });
  }, true);

  /* ---------- requetes panier des autres scripts ---------- */
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)|\/discount\//;
  function onExternal(url) {
    if (!RX.test(url) || /[?&]rc=1(&|$)/.test(url)) return;
    if (/\/cart\/update/.test(url) && !isOpen) { dirty = true; return; }
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 250);
  }
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) { onExternal(en.name); });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) { /* navigateur ancien : le panier se rafraichit a l'ouverture */ dirty = true; }
  }

  /* Page restauree depuis le cache (bouton retour) : le panier a pu changer. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.RcCart = { enabled: true, open: open, close: close, refresh: refresh };
  syncCount();
  syncAll();
})();
